import { useEffect, useState } from "react";
import { api } from "../api/client";

interface Company {
  id: string;
  name: string;
  slug: string;
  dataRoot?: string;
  isActive: boolean;
  planId: string | null;
  parentCompanyId: string | null;
  createdAt: string;
  updatedAt: string;
}

export function Clients() {
  const [env, setEnv] = useState<"prod" | "stage">("prod");
  const [companies, setCompanies] = useState<Company[]>([]);
  const [q, setQ] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api
      .clients(env)
      .then((d) => {
        setCompanies(d.companies as Company[]);
        setErr(null);
      })
      .catch((e) => setErr(String(e)))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [env]);

  const filtered = q
    ? companies.filter(
        (c) =>
          c.name.toLowerCase().includes(q.toLowerCase()) ||
          c.slug.toLowerCase().includes(q.toLowerCase()),
      )
    : companies;

  return (
    <div className="space-y-4">
      <header className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-xl font-semibold">Клиенты</h1>
          <p className="text-sm text-panel-muted">
            Компании Coagent через admin API · всего {companies.length}
            {filtered.length !== companies.length && ` · найдено ${filtered.length}`}
          </p>
        </div>
        <div className="flex gap-2">
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="поиск по имени или slug…"
            className="w-64 rounded border border-panel-border bg-panel-bg px-3 py-1.5 text-sm"
          />
          {(["prod", "stage"] as const).map((e) => (
            <button
              key={e}
              onClick={() => setEnv(e)}
              className={"btn text-xs " + (env === e ? "btn-primary" : "")}
            >
              {e}
            </button>
          ))}
        </div>
      </header>

      {err && <div className="card pill-err border-panel-err">Ошибка: {err}</div>}
      {loading && <div className="text-xs text-panel-muted">Загрузка…</div>}

      <div className="card overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="text-xs text-panel-muted">
            <tr>
              <th className="pb-2 pr-3">Компания</th>
              <th className="pb-2 pr-3">Slug</th>
              <th className="pb-2 pr-3">Статус</th>
              <th className="pb-2 pr-3">План</th>
              <th className="pb-2 pr-3">Тип</th>
              <th className="pb-2">Создано</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((c) => (
              <tr key={c.id} className="border-t border-panel-border">
                <td className="py-1.5 pr-3">
                  <div className="font-medium">{c.name}</div>
                  <div className="text-[10px] text-panel-muted">{c.id}</div>
                </td>
                <td className="py-1.5 pr-3 font-mono text-xs text-panel-muted">{c.slug}</td>
                <td className="py-1.5 pr-3">
                  <span className={`pill ${c.isActive ? "pill-ok" : "pill-err"}`}>
                    {c.isActive ? "active" : "disabled"}
                  </span>
                </td>
                <td className="py-1.5 pr-3 text-xs text-panel-muted">{c.planId ?? "—"}</td>
                <td className="py-1.5 pr-3 text-xs">
                  {c.parentCompanyId ? (
                    <span className="pill" title={c.parentCompanyId}>
                      child
                    </span>
                  ) : (
                    <span className="text-panel-muted">root</span>
                  )}
                </td>
                <td className="py-1.5 text-xs text-panel-muted">
                  {new Date(c.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
            {!loading && filtered.length === 0 && (
              <tr>
                <td colSpan={6} className="py-3 text-center text-xs text-panel-muted">
                  {companies.length === 0
                    ? "Нет данных. Проверь COAGENT_ADMIN_TOKEN в настройках."
                    : "Нет совпадений по фильтру."}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
